import { autoserialize, autoserializeAs } from 'cerialize';
import { Driver } from './driver';

export class FavoriteDriver {
  @autoserialize
  riderId: number;

  @autoserializeAs(Driver)
  driver: Driver;
}
